import { HttpHeader, ContentType } from './constants.js';
import { ApiError } from './errors.js';
import { ModuleConfig } from '../utility/module.js';
import { notifyError } from '../notifications/actions.js';

var defaultOptions = {
  apiUrl: "",
  preventErrorNotification: false,
  onErrorNotification: function onErrorNotification(message) {
    return notifyError(message);
  },
  preventResponseHandling: false,
  fetchFailureError: "Network connection unavailable",
  onErrorResponse: function onErrorResponse(response) {
    return new Promise(function (resolve) {
      var responseType = response.headers.get(HttpHeader.ContentType);

      if (responseType && responseType.includes(ContentType.Json)) {
        response.json().then(function (data) {
          return resolve(new ApiError(data, response.status));
        }).catch(function (error) {
          return resolve(new ApiError(error.message, response.status));
        });
      } else if (responseType && responseType.includes(ContentType.Text)) {
        response.text().then(function (data) {
          return resolve(new ApiError(data, response.status));
        }).catch(function (error) {
          return resolve(new ApiError(error.message, response.status));
        });
      } else {
        resolve(new ApiError("An unexpected error has occurred", response.status));
      }
    });
  }
};
var config = new ModuleConfig(defaultOptions);
/**
 * Gets current configuration options for the api module
 * @returns {object} Api module options
 */

var getApiModuleOptions = function getApiModuleOptions() {
  return config.getAll();
};
/**
 * Configures options for the api module
 * @param {object} options Options to set
 * @param {string} options.apiUrl Default host address for API calls
 * @param {function} options.onErrorNotification Redux action creator that will be dispatched whenever an error notification event occurs, default implementation is to send the error to the Notifications module
 * @param {boolean} options.preventErrorNotification Whether to disable error notification events as a result of failed API calls, default false
 * @param {boolean} options.preventResponseHandling Whether to disable response handling for requests, default false
 * @param {string} options.fetchFailureError Error message to display when a fetch request fails, default "Network connection unavailable"
 * @param {function} options.onErrorResponse The function used to convert a response to an ApiError when a fetch request returns an error
 */


var setApiModuleOptions = function setApiModuleOptions(options) {
  return config.setAll(options);
};
/**
 * Alias for getApiModuleOptions
 */


var getApiOptions = function getApiOptions() {
  return getApiModuleOptions();
};
/**
 * Alias for setApiModuleOptions
 */


var setApiOptions = function setApiOptions(options) {
  return setApiModuleOptions(options);
};

export { getApiModuleOptions, getApiOptions, setApiModuleOptions, setApiOptions };
